import { useState, useRef } from "react";
import { createPortal } from "react-dom";

const TruncatedTooltipText = ({ text, className = "metric-value", Tag = "h4", tagClassName = "", onlyWhenTruncated = false }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipStyle, setTooltipStyle] = useState({});
  const valueRef = useRef(null);

  const handleMouseEnter = () => {
    if (valueRef.current) {
      const rect = valueRef.current.getBoundingClientRect();
      const isTruncated = valueRef.current.scrollWidth > valueRef.current.clientWidth;

      if (onlyWhenTruncated && !isTruncated) return;

      setTooltipStyle({
        position: 'fixed',
        top: rect.top - 8,
        left: rect.left + rect.width / 2,
        transform: 'translate(-50%, -100%)',
        zIndex: 999999,
        width: 'max-content',
        maxWidth: '320px',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        pointerEvents: 'none',
      });
      setShowTooltip(true);
    }
  };

  const handleMouseLeave = () => setShowTooltip(false);

  return (
    <div
      className={className}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Tag ref={valueRef} className={tagClassName || undefined}>{text}</Tag>

      {showTooltip && text && createPortal(
        <div className="metric-tooltip-fixed" style={tooltipStyle}>
          {text}
        </div>,
        document.body
      )}
    </div>
  );
};

export default TruncatedTooltipText;
